export type ActiveRole = 'user' | 'merchant' | undefined;

function setHrefForSelector(selector: string, href: string) {
  const links = document.querySelectorAll<HTMLLinkElement>(selector);
  links.forEach((link) => {
    link.setAttribute('href', href);
    // Ensure correct type for SVG icons
    if (!link.getAttribute('type')) {
      link.setAttribute('type', 'image/svg+xml');
    }
  });
}

export function updateFaviconForRole(role: ActiveRole) {
  const iconPath = role === 'merchant' ? '/logo-merchant.svg' : '/logo.svg';
  setHrefForSelector('link[rel="icon"]', iconPath);
  setHrefForSelector('link[rel="shortcut icon"]', iconPath);
  setHrefForSelector('link[rel="apple-touch-icon"]', iconPath);
}
